/**
 * Verifica se o erro é de acesso não autorizado
 */
export const isAcessoNegado = (error: any): boolean => {
    if (!error) return false;
    
    const message = error?.message || error?.response?.data?.message || '';
    const status = error?.response?.status;
    
    // Verificar por mensagem
    if (typeof message === 'string') {
        const messageLower = message.toLowerCase();
        if (
            messageLower.includes('acesso não autorizado') ||
            messageLower.includes('acesso nao autorizado') ||
            messageLower.includes('unauthorized') ||
            messageLower.includes('não autorizado') ||
            messageLower.includes('nao autorizado')
        ) {
            return true;
        }
    }
    
    // Verificar por status HTTP
    if (status === 401 || status === 403) {
        return true;
    }
    
    return false;
};


